<app-header></app-header>
<div class="home-container">
  <div class="home-content">
    @if (showLogAnalyticsQuery) {
      <app-log-analytics-query></app-log-analytics-query>
    }
    <div class="clickable-chart" (click)="navigateToAlertsBreakdown()">
      <app-la-alerts-by-team></app-la-alerts-by-team>
    </div>
  </div>
  <div class="announcements-container mat-elevation-z2">
    <app-announcements [hideHeader]="true"></app-announcements>
  </div>
</div>
